<template>
	<div class="msg-wrap">
		<div class="msg-pannel" >
			<div class="msg-header">
				<div class="msg-total">共 <span class="num">{{ commentCount }}</span> 条评论</div>
				<div class="msg-sort">
					<span :class="{active: form.order === 'new'}" @click="changeOrder('new')">最新排序</span>
					<i class="split">|</i>
					<span :class="{active: form.order === 'recommend'}" @click="changeOrder('recommend')">推荐排序</span>
				</div>
			</div>
			<div class="msg-pannel-scroll" >
				<div class="scroll-item no-msg-container" v-if="msgList.length == 0">
					<div class="no-msg">
						<div class="no-msg-text">暂无评论</div>
						<div class="no-msg-desc" v-if="type==1">快来晒出你的新头像吧~</div>
						<div class="no-msg-desc" v-if="type==2">为这个拍品打个call吧~</div>
					</div>
				</div>
				
                <div v-for="(item, index) in msgList" :key="index" >
					<div class="scroll-item ">
						<img class="avatar" :src="item.user.avatar" alt="" />
						<div class="msg-r line">
							<div class="user-name">{{ item.user.nickname || '' }}</div>
							<div class="msg-val" :class="{del: item.isdel}">{{ item.content || '' }}</div>
							<div class="imgbox">
								<el-image class="img" :src="img.url" v-for="(img, imgind) in item.images" :key="img.id" :initial-index="imgind" :preview-src-list="geiImgList(item.images)" fit="contain" />
							</div>
							<div class="like-wrap">
								<div class="time">回复时间：{{ item.ctime_ago || (item.ctime | timeFilter) }}</div>
								<div class="like-nums" :class="{liked: item.islike == 1}" v-if="item.id">
									<img class="like"  @click="likeClick(item, index)" :src="item.islike == 1 ? require('../../assets/images/like-h.png') : require('../../assets/images/like.png')" alt="" />
									<div class="count_like" >{{item.count_like||0}}</div>
								</div>
								<div class="reply-text"  v-if="item.id" @click="reply(item, '-1', index)">回复</div>
								<div class="reply-text del-btn"  @click="delmsg(item, '-1', index)" v-if="userInfo && userInfo.id==item.user_id">删除</div>

							</div>

							<div  class="reply-parent child-msg" v-if="item.child && item.child.length">
								<div class="scroll-item " v-for="(items, idx) in item.child.slice(0, item.limit)" :key="idx">
									<img class="avatar" :src="items.user.avatar" alt="" />
									<div class="msg-r">
										<div class="user-name">{{ items.user.nickname || '' }}</div>
										<div class="msg-val" :class="{del: items.isdel}">{{ items.content || '' }}</div>
										<div class="imgbox">
											<el-image class="img" :src="img.url" v-for="(img, imgind) in items.images" :initial-index="imgind" :preview-src-list="geiImgList(items.images)" :key="img.id" fit="contain" />
										</div>
										<div class="like-wrap">
											<div class="time">回复时间：{{ items.ctime_ago || (items.ctime | timeFilter) }}</div>
											<div class="like-nums" :class="{liked: items.islike == 1}">
												<img class="like"  @click="likeClick(items, idx, index)" :src="items.islike == 1 ? require('../../assets/images/like-h.png') : require('../../assets/images/like.png')" alt="" />
												<div class="count_like" >{{items.count_like||0}}</div>
											</div>

											<div class="reply-text" @click="reply(items, idx, index)">回复</div>
											<div class="reply-text  del-btn" @click="delmsg(items, idx, index)" v-if="userInfo && userInfo.id == items.user_id">删除</div>

										</div>
									</div>
								</div>
								<div class="show-all" v-if="item.child && item.child.length > 2 && !item.all">共 {{ item.child.length || 0}}条回复, <span @click="seeAll(index)">点击查看</span> </div>
							</div>

							<div class="msg-pannel-input big" v-if="userInfo && item.replyShow && replyIndex == index">
								<img :src="userInfo.avatar" alt="" style="margin-top: 42px;">
								<!-- <el-input class="input" type="textarea" :placeholder="placeholder" v-model="childval" :rows="2"/> -->
								<div class="inpbox">
									<div class="inpgn">
										<el-upload :action="upLoadUrl" :file-list="filelist" multiple :show-file-list="false" :limit="5 - images.length" :http-request="handleUpload" :on-exceed="exceedImg">
											<img src="@/assets/images/camera.png" />
										</el-upload>
									</div>
									<div class="inpcon">
										<el-input class="input" type="textarea" :placeholder="placeholder" v-model="childval" :rows="2"/>
										<div class="imginp" v-if="images.length">
											<div class="imgitem" v-for="(img, ind) in images" :key="img.id">
												<i class="el-icon-error close" @click="removeImg(ind)"></i>
												<el-image class="img" :src="img.url"  :initial-index="0" :preview-src-list="[img.url]" fit="contain" />
											</div>
										</div>
									</div>
								</div>
								<div class="el-btn" style="margin-top: 42px;">
									<el-button type="primary" size="small" @click="changeInput('childval')">发表 <br /> 评论</el-button>
								</div>
							</div>

						</div>
					</div>
					<!-- <div class="msg-pannel-input" v-if="userInfo && item.replyShow && replyIndex == index">
                        <img :src="userInfo.avatar" alt="">
                        <el-input class="input" type="textarea" :placeholder="placeholder" v-model="childval" :rows="2"/>
                        <div class="el-btn">
                            <el-button type="primary" size="small" @click="changeInput('childval')">发表 <br /> 评论</el-button>
                        </div>
                    </div> -->
                </div>
			</div>
		</div>

	

        <Pagination
			v-if="totalPage"
            :totalPage="totalPage"
            :limit="form.limit"
            @changePage="handleCurrentChange"
        ></Pagination>

		<div class="msg-pannel-input big" v-if="userInfo && pInput">
			<img :src="userInfo.avatar" alt="" style="margin-top: 42px;">
			<div class="inpbox">
				<div class="inpgn">
					 <el-upload :file-list="filelist" :action="upLoadUrl" multiple :show-file-list="false" :limit="5 - images.length" :http-request="handleUpload" :on-exceed="exceedImg">
						<img src="@/assets/images/camera.png" />
					</el-upload>
				</div>
				<div class="inpcon">
					<el-input class="input" type="textarea" placeholder="为这个拍品打个call吧~" v-model="val" :rows="2"/>
					<div class="imginp" v-if="images.length">
						<div class="imgitem" v-for="(img, ind) in images" :key="img.id">
							<i class="el-icon-error close" @click="removeImg(ind)"></i>
							<el-image class="img" :src="img.url"  :initial-index="0" :preview-src-list="[img.url]" fit="contain" />
						</div>
					</div>
				</div>
			</div>
			<div class="el-btn" style="margin-top: 42px;">
				<el-button type="primary" size="small" @click="changeInputAll('val')">发表 <br /> 评论 </el-button>
			</div>
		</div>

		
	</div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";
import { apiBaseUrl } from '@/config/env.js'
import { mapState } from 'vuex';

export default {
    components: {  Pagination },
	props: ['relId','type'],
    filters: {
        timeFilter(val) {
			if(val) {
				let end = val.length - 3
            	return val.substr(0, end)
			} else {
				return '刚刚'
			}
           
        }
    },
	data() {
		return {
			msgShow: true,
			msgList: [],
			commentCount: 0,
			val: '',
			childval: '',
			commentId: 0,
			placeholder: "为这个拍品打个call吧~",
            form: {
                page:1,
                limit: 6,
                order: 'new'
            },
            totalPage: 0,
			replyIndex: -1,
			pInput:  true,
			IndexObj: {},
			upLoadUrl: apiBaseUrl + 'api.html',
			images: [],
			filelist: []
		};
	},
	created() {
		this.userInfo = this.$storage.get("userInfo") || {}
		this.getList();
	},
	methods: {
		// 删除图片
		removeImg (key) {
			this.images.splice(key, 1)
			this.filelist.splice(key, 1)
		},
		exceedImg(){
			this.$msg("评价图片最多上传五张", 'error')
		},
		//上传图片
		handleUpload(e) {
			if(e.file.size > 1024 * 1024) {
				this.$msg("图片大小不能超过 1M,请重新上传", 'error')
				return
			}
			if(this.images.length >= 5) {
				this.$msg("评价图片最多上传五张", 'error')
				return
			}
			var formdata = new FormData()
			formdata.append('upfile', e.file, e.file.name)
			this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
				if (res.status) {
				let img = {
					url: res.data.url,
					id: res.data.image_id,
				}
				this.images.push(img)
				} else {
				this.$msg(res.msg, 'error')
				}
			})
		},
		geiImgList(data) {
			let list = []
			data.forEach(item => {
				list.push(item.url)
			})
			return list
		},
		delmsg(item, index, parent) {
			console.log('parent', parent);
			let data = {}
			data.id = item.id
			this.$api.delTopic({...data}).then(res => {
				this.$message ({
					message: res.msg,
					type: res.status ? 'success': 'error'
				})
				if(res.status) {
					this.msgList.splice(parent, 1)
					// this.getList();
				}
			})
		},
        handleCurrentChange(val) {
            this.form.page = val
            this.getList();
        },
		seeAll(index) {
			this.msgList[index].limit = this.msgList[index].child.length  
			this.msgList[index].all = true

		},
        likeClick(item, index, parent) {
			
			this.$api.liketopic({
				topic_id: item.id
			}).then(res => {
				if(res.status) {
					if(typeof parent == 'number') {
						this.msgList[parent].child[index].islike = res.msg == '点赞成功' ? 1 : 0

					} else {
						this.msgList[index].islike = res.msg == '点赞成功' ? 1 : 0

					}
					
					if(res.msg == '点赞成功') {
						if(typeof parent == 'number') {
							this.msgList[parent].child[index].count_like += 1
						} else {
							this.msgList[index].count_like += 1
						}
					} else {
						if(typeof parent == 'number') {
							this.msgList[parent].child[index].count_like -= 1
						} else {
							this.msgList[index].count_like -= 1
						}
					}
					
				}
			})
		},
		reply(item, index, prent) {

			console.log(item, index, prent)
			// let idx = prent || index || 0

			// this.commentId =  this.msgList[idx].replyShow ? 0 : item.id
			// this.replyIndex = idx
			// this.pInput = this.msgList[idx].replyShow
			// this.msgList[idx].replyShow = !this.msgList[idx].replyShow


			// let str = item.content
			// if(item.content.length >=10) {
			// 	str = item.content.substr(0, 7) + '......'
			// } 
			// this.placeholder = '回复:' + item.user.nickname+ ':' + str

			this.IndexObj = {
				cindex: index,
				pindex: prent
			}
			let idx 
			let str = item.content || {content: ''}
				
			if(index == '-1') {
				idx = prent
				this.pInput = this.msgList[idx].replyShow
				this.commentId =   item.id
				this.msgList[idx].replyShow = !this.msgList[idx].replyShow
				this.replyIndex = idx
				this.placeholder = '回复:' + item.user.nickname+ ':' + str
			} else {

				if(typeof prent == 'number' && prent == 0) {
					idx = prent 

				} else {
					idx = prent || index || 0
				}

				
				this.replyIndex = idx
				this.pInput = this.msgList[idx].replyShow
				this.msgList[idx].replyShow = !this.msgList[idx].replyShow
				// this.commentId =  this.msgList[idx].replyShow ? 0 : item.id
				this.commentId =   item.id
				
				if(prent == index) {
					this.placeholder = str
				} else {
					this.placeholder = '回复:' + item.user.nickname+ ':' + str
				}
				if(item.content.length >=10) {
					str = item.content.substr(0, 7) + '......'
				} 
			}
				
		},
		getList() {
			let data = {
				type: this.type,
				rel_id: this.relId,
                ...this.form
			};
			this.$api.listtopic(data).then(res => {
                this.totalPage = Math.ceil( res.data.count / this.form.limit);
                this.commentCount = res.data.count_topic || 0;
                let listdata = res.data.list
                if(listdata.length) {
                    listdata.forEach(element => {
                        element.replyShow = false
                        element.limit = 2
                        element.all = false
                    });
                }
				this.msgList = listdata;
			});
		},

		changeOrder(type) {
			if(this.form.order === type) return;
			this.form.order = type;
			this.form.page = 1;
			this.getList();
		},

		msgBot() {
			this.msgShow = !this.msgShow;
		},

		changeInput() {
			const _this = this
			if (!this.childval) {
				this.$message({
					message: '为这个拍品打个call吧~',
					type: 'error'
				});
				return;
			}
			let data = {
				comment_id: this.commentId, //父级评论id，给谁回复的
				type: this.type,
				rel_id: this.relId,
				content: this.childval,
			};

			if(this.images.length) {
				let ids = []
				this.images.forEach(item => {
					ids.push(item.id)
				})
				data['image_ids'] = ids
			}
			
			let {pindex, cindex} = this.IndexObj
			
			if(typeof pindex == 'number') {
				if(this.msgList[pindex].child[cindex]) {
					data.content = `回复@${this.msgList[pindex].child[cindex].user.nickname}: ${this.childval}`
				} 
				data.comment_id = this.msgList[pindex].id
			}
			this.$api.addtopic(data).then(res => {
				this.$message({
					message: res.msg,
					type: res.status ? 'success' : 'warning'

				});
				if (res.status) {
					if(cindex == '-1' || typeof pindex == 'number') {
						_this.msgList[pindex].child = [..._this.msgList[pindex].child, res.data]
						if(_this.msgList[pindex].all) {
							_this.msgList[pindex].limit = _this.msgList[pindex].child.length
						}
					}
					
					this.childval = '';
					this.images = []
					this.commentId = 0
					this.IndexObj = {}
					this.replyIndex = -1
					this.pInput = true
					
				}
			});
		},
		changeInputAll(val) {

			this.IndexObj= {}
			this.commentId = 0


			const _this = this
			if (!this.$data[val]) {
				this.$message({
					message: '为这个拍品打个call吧~',
					type: 'error'
				});
				return;
			}
			let data = {
				comment_id: this.commentId, //父级评论id，给谁回复的
				type: this.type,
				rel_id: this.relId,
				content: this.$data[val],
			};

			if(this.images.length) {
				let ids = []
				this.images.forEach(item => {
					ids.push(item.id)
				})
				data['image_ids'] = ids
			}

			this.$api.addtopic(data).then(res => {
				this.$message({
					message: res.msg,
					type: res.status ? 'success' : 'warning'
				});

				if (res.status) {

					if(this.commentId == 0) {
						this.msgList.push( res.data)
					} else {
						this.getList()
					}
					

					this.$data[val] = '';
					this.images = []
					this.commentId = 0
					this.pInput = true
				}
			});
		},
		// changeInput() {
		// 	const _this = this
		// 	if (!this.val) {
		// 		this.$message({
		// 			message: '为这个拍品打个call吧~',
		// 			type: 'error'
		// 		});
		// 		return;
		// 	}
		// 	let data = {
		// 		comment_id: this.commentId, //父级评论id，给谁回复的
		// 		type: this.type,
		// 		rel_id: this.relId,
		// 		content: this.val,
		// 	};
		// 	this.$api.addtopic(data).then(res => {
		// 		this.$message({
		// 			message: res.msg,
		// 			type: res.status ? 'success' : 'warning'
		// 		});

		// 		if (res.status) {
		// 			this.getList()
		// 			this.val = '';
		// 			this.commentId = 0
		// 		}
		// 	});
		// }
	}
};
</script>

<style lang="scss" scoped>
$msg-main-color: #fdac03;

/* 设置滚动条的样式 */
::-webkit-scrollbar {
	width: 12px;
}
/* 滚动槽 */
::-webkit-scrollbar-track {
	-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
	border-radius: 10px;
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
	border-radius: 10px;
	background: rgba(0, 0, 0, 0.1);
	-webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
::-webkit-scrollbar-thumb:window-inactive {
	background: rgba(255, 0, 0, 0.4);
}
.msg {
	&-bot {
		position: fixed;
		bottom: 20px;
		right: 1px;
		display: inline-block;
		padding: 0 12px;
		background-color: $msg-main-color;
		vertical-align: middle;
		cursor: pointer;
		border-radius: 5px 0 0 5px;
		height: 36px;
		line-height: 36px;
		min-width: 100px;
		max-width: 300px;
		z-index: 99;
		color: #fff;
		text-align: center;
		.chat-nothing-to-read {
			vertical-align: middle;
			height: 6px;
			width: 6px;
			border-radius: 50%;
			background: #8ee52f;
			display: inline-block;
		}
		.el-icon-chat-dot-square {
			width: 30px;
			height: 30px;
			font-size: 18px;
		}
	}
	&-pannel {
		z-index: 99;
		bottom: 20px;
		right: 1px;
		border-radius: 5px;
		&-title {
			background: $msg-main-color;
			height: 35px;
			text-align: center;
			line-height: 35px;
			color: #fff;
			cursor: pointer;
			position: relative;
			.el-icon-close {
				position: absolute;
				right: 20px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		&-scroll {
			display: flex;
			flex-direction: column;
			.scroll-item {
				padding: 10px;
				display: flex;
				position: relative;
				width: 800px;
				.avatar {
					width: 50px;
					height: 50px;
					flex: 0 0 50px;
					overflow: hidden;
					border-radius: 50%;
				}
				.time {
					margin-right: 10px;
					font-size: 12px;
				}
				
				.msg-r {
					padding-left: 10px;
					position: relative;
					flex: 1;
					padding-bottom: 10px;
					&.line {
						border-bottom: 1px solid #e5e9ef;
					}
					&::before {
						content: '';
						position: absolute;
						top: 24px;
						z-index: 10;
						left: 4px;
						width: 0;
						height: 0;
						border-top: 6px solid transparent;
						border-bottom: 6px solid transparent;
						border-right: 6px solid #fff;
					}
					.user-name {
						display: block;
						position: relative;
						margin-bottom: 5px;
						color: #6d757a;
						font-size: 14px;
						width: 100%;
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						font-weight: bold;
					}

					.msg-val {
						position: relative;
						box-sizing: border-box;
						display: inline-block;
						max-width: 650px;
						overflow: wrap;
						padding: 0 7px 0px 0;
						font-size: 14px;
						border-radius: 5px;
						word-break: break-all;
						word-wrap: break-word;
						background: #fff;
						line-height: 20px;
						margin-bottom: 10px;
						&.del {
							color: #666;
						}
					}
					.imgbox {
						display: flex;
						gap: 10px;
						flex-wrap: wrap;
						margin: 10px 0;
						.img {
							width: 60px;
							height: 60px;
						}
					}
					.reply-parent {
						background: #e8e8e8;
						padding: 8px 10px;
						margin-top: 8px;
						border-radius: 4px;
						font-size: 12px;
						color: #848484;
						width: 240px;
						max-height: 36px;
						line-height: 20px;

						text-overflow: -o-ellipsis-lastline;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 2;
						line-clamp: 2;
						-webkit-box-orient: vertical;

						&.child-msg {
							background: #fff;
							max-height: initial;
							line-height: initial;
							width: 700px;
							.scroll-item {
								padding: 2px 10px;
							}
							.avatar{
								width: 30px;
								height: 30px;
								flex: 0 0 30px;
							}
							.msg-val {
								font-size: 14px;
							}
							.like-wrap {
								font-size: 12px;
								.like {
									width: 16px;
									height: 16px;
									cursor: pointer;
								}
							}
						}
					}
				}

			}
		}
		&-input {
			bottom: 0;
			left: 0;
			right: 0;
			display: flex;
			align-content: center;
			padding-left: 20px;
			margin: 10px 0;
			&.big {
				padding-left: 0;
				.inpbox {
					flex: 1;
					.inpcon {
						border: 1px solid #DCDFE6;
						border-radius: 2px;
					}
					.inpgn {
						display: flex;
						padding: 10px 5px;
						img {
							width: 20px;
							height: 20px;
							cursor: pointer;
							user-select: none;
						}
					}
					.imginp {
						display: flex;
						gap: 10px;
						margin-top: 10px;
						padding: 10px;
						.img {
							width: 60px;
							height: 60px;
						}
						.imgitem {
							position: relative;
							.close {
								position: absolute;
								right: -10px;
								top: -10px;
								z-index: 99;
								font-size: 20px;
								cursor: pointer;
								user-select: none;
							}
						}
					}
				}
			}
			img {
				width: 54px;
				height: 54px;
				margin-right: 10px;
			}
			.el-btn {
				display: flex;
				align-items: center;
				margin-left: 10px;
				height: 54px;
				.el-button--small {
					height: 54px;
				}
			}
		}
	}
}

.msg-wrap ::v-deep .el-input__inner {
	border: none;
	width: 100%;
	background: #f9f9f9;
}

.msg-wrap ::v-deep .el-pagination {
	height: 30px;
}

.msg-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 8px 0 12px;
}
.msg-total {
	color: #333;
	font-size: 14px;
	.num {
		color: #ff6a00;
		font-weight: 600;
		padding: 0 2px;
	}
}
.msg-sort {
	font-size: 14px;
	color: #666;
	user-select: none;
	span {
		cursor: pointer;
		padding: 2px 4px;
	}
	.split {
		margin: 0 6px;
		color: #ccc;
	}
	.active {
		color: #409eff;
		font-weight: 600;
	}
}

.like-wrap {
	display: flex;
	align-items: center;
	line-height: 22px;
	height: 25px;
	.like-nums {
		display: flex;
		align-items: center;
		min-width: 40px;
		padding: 2px 2px;
		background: #e8f3ff;
		border: 1px solid #d0e7ff;
		border-radius: 4px;
		transition: all .2s;
		&.liked {
			background: #e6f7ff;
			border-color: #91d5ff;
		}
	}
	.like {
		width: 20px;
		height: 20px;
		cursor: pointer;
	}
	/* div {
		color: #000;
		opacity: .4;
	} */
	.reply-text {
		margin-left: 10px;
		cursor: pointer;
		font-size: 12px;
		height: 22px;
		line-height: 24px;
	}
	.count_like {
		margin: 0 4px;
	}
}

.show-all {
	font-size: 12px;
	color: #6d757a;
	margin: 10px 0;
	span {
		outline: none;
		color: #00a1d6;
		text-decoration: none;
		cursor: pointer;
		padding: 2px 3px;
		border-radius: 4px
	}
}

.no-msg-container {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 200px;
	padding: 40px 20px;
	
	.no-msg {
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		
		.no-msg-text {
			font-size: 18px;
			color: #666;
			font-weight: 500;
			margin-bottom: 8px;
		}
		
		.no-msg-desc {
			font-size: 14px;
			color: #999;
			line-height: 1.4;
		}
	}
}

::v-deep .el-textarea__inner {
	border: 0!important;
}
</style>
